import styled from 'styled-components'
import { ImgComponent } from 'Pages/landings/newLandings/common/components'
import { media, Breakpoints, WrapperBlock, gridTwo } from 'Pages/landings/newLandings/common/style'

export const Wrapper = styled(WrapperBlock)<{ styled: string }>`
	${gridTwo}
	grid-template-columns: 1fr;
	grid-template-rows: auto auto;
	${media('align-items: center;', Breakpoints.ms)};
	${media('column-gap: 80px;', Breakpoints.xl)};
	${({ styled }) => styled}}
`
export const Img = styled.img`
	object-fit: cover;
	width: 100%;
	height: 100%;
	border-radius: 16px;
`
export const ImgWrapper = styled(ImgComponent)`
	max-height: 400px;
	order: 1;
`
export const Info = styled.div<{ isReverse: boolean }>`
	display: flex;
	flex-direction: column;
	order: 2;
	${media('order: 0;', Breakpoints.ms)};
	${({ isReverse }) => isReverse && media('order: 2;', Breakpoints.ms)}
`
